
import collect from 'collect.js'
import Times from '@/assets/icons/fontawesome/light/times.svg?inline'
import Check from '@/assets/icons/fontawesome/light/check.svg?inline'

export default {
  components: {
    Times,
    Check,
  },

  props: {
    filters: {
      type: Array,
      required: true,
    },
    showAll: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    categories() {
      return collect(this.filters)
        .groupBy('category')
        .filter((category) => category.count() > 1)
        .all()
    },
  },
}
